// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__88EQr","rotate":"Loader_rotate__fG4cK","prixClipFix":"Loader_prixClipFix__GOIXs"};